/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { DRUG_NAME_REQUIRED } from '../../../../../SharedModules/AppConstants';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import {
  searchNDCByIDORDrugName,
  setNDCErrorPopupMessage,
  setNDCLoading,
  setSearchByDrugNameTableData,
  setSearchByDrugName,
} from '../../store/action';

const SearchComponent = ({ callback, loadingFunc, setError }) => {
  const dispatch = useDispatch();
  // const [searchByDrugName, setSearchByDrugName] = useState('');
  const searchByDrugName = useSelector(
    (state) => state.sharedState.ndc.searchByDrugName
  );
  const setLoading = (value) => {
    dispatch(setNDCLoading(value));
  };

  const handleSearchClick = async () => {
    if (!searchByDrugName && !searchByDrugName.trim()) {
      if (setError) {
        setError(DRUG_NAME_REQUIRED);
      } else {
        dispatch(setNDCErrorPopupMessage(DRUG_NAME_REQUIRED));
      }
    } else {
      if (loadingFunc) {
        loadingFunc(true);
      } else {
        setLoading(true);
      }
      const searchResult = await searchNDCByIDORDrugName({
        searchBy: 'drugName',
        inputValue: searchByDrugName,
        page: 0,
        pageSize: 1000000000,
      });

      if (callback) {
        callback(searchResult);
      } else {
        if (!searchResult) {
          dispatch(setNDCErrorPopupMessage('NDC Not Found'));
        } else {
          dispatch(setNDCErrorPopupMessage(null));
        }

        dispatch(setSearchByDrugNameTableData(searchResult || []));
        setLoading(false);
      }
    }
  };

  return (
    <div className="d-flex align-items-end justify-content-end search-ndc">
      <div className="mui-custom-form m-0">
        <TextField
          id='drugName'
          label="Enter a Drug name"
          fullWidth
          required
          inputProps={{ maxlength: 30, id: 'drugName' }}
          InputLabelProps={{
            shrink: true,
          }}
          value={searchByDrugName}
          onChange={(e) => {
            dispatch(setSearchByDrugName(e.target.value));
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSearchClick();
            }
          }}
        />
      </div>

      <Button className="btn btn-success btn-view" onClick={handleSearchClick}>
        <SVGComponent iconName="Icon-search" />
        Search
      </Button>
    </div>
  );
};

export default SearchComponent;
